<template>
  <template v-if="!isFetching && !isDeleting">
    <q-btn-dropdown
      color="primary"
      split
      @click="data && data.length > 0 ? fetchPDFs(data, field) : undefined"
    >
      <template #label>
        {{ formLabel('downloadPDFs') }}
        {{ data && data.length > 0 ? data.length : undefined }}
      </template>
      <q-list>
        <q-item clickable v-close-popup @click.stop="deletePDFs(data, field)">
          <q-item-section>
            <q-item-label>{{ formLabel('deletePDFs') }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
  </template>
  <template v-if="isFetching || isDeleting">
    <q-btn
      flat
      no-caps
      class="text-primary"
      :label="isFetching ? 'Cancel Download' : 'Cancel Delete'"
      @click.stop="cancelFetch()"
    />
  </template>

  <q-circular-progress
    v-if="isFetching"
    :min="0"
    :max="data ? data.length : undefined"
    :value="fetchProgress"
    size="20px"
    :thickness="0.22"
    :color="progressColor"
    :indeterminate="progressIndeterminate"
    track-color="grey-3"
    class="q-ma-md"
  />
</template>
<script lang="ts">
import { useI18n } from 'vue-i18n'
import { useNetwork } from '../composables/useNetwork'
import { useQueuePDFs } from '../composables/useQueuePDFs'
import { computed, defineComponent, PropType, watch } from 'vue'

export default defineComponent({
  emits: ['isFetching'],
  props: {
    data: {
      required: true,
      type: Array as PropType<{ [key: string]: string }[]>,
    },
    field: {
      required: true,
      type: String,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n({ useScope: 'global' })
    const formLabel = (key: string) => t(`form.${key}`)

    const { isFetching, isDeleting, fetchProgress, fetchPDFs, cancelFetch, deletePDFs } =
      useQueuePDFs()
    const { getStatus } = useNetwork()
    const progressColor = computed(() => {
      if (getStatus.value) return 'teal'
      else return 'red'
    })
    const progressIndeterminate = computed(() => {
      if (getStatus.value) return false
      else return true
    })
    watch(isFetching, () => {
      emit('isFetching', isFetching.value)
    })
    return {
      getStatus,
      progressColor,
      progressIndeterminate,
      isFetching,
      isDeleting,
      fetchProgress,
      fetchPDFs,
      cancelFetch,
      deletePDFs,
      formLabel,
    }
  },
})
</script>
